import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchPublicSettings = async (storeId) => {
    try {
        const headers = storeId ? { 'X-Store-Id': storeId } : undefined;
        const response = await axios.get(`${API_URL}/api/settings/public`, { headers });
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};